import { app_login_children } from "dependencies/login/index.js"
// import icon from "../../../../assets/images/leftMenu/basePortal/icon_search.png"
let icon = "icon-portal-login"
export default {
  name: "登录框",
  id: "",
  thumbnail: icon,
  type: "cxSystemLogin",
  componentType:"emptyLayoutComponent",
  // typeId: "29fde2dc8a85e111ed0b1e484b549cca744f",
  typeId: "",
  children: app_login_children
}
